var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError503(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 387.77 223.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#fff;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:url(#linear-gradient-6);}.cls-9{fill:url(#linear-gradient-7);}.cls-10{fill:url(#linear-gradient-8);}.cls-11{fill:url(#linear-gradient-9);}.cls-12{fill:url(#linear-gradient-10);}.cls-13{fill:#cec4d6;}.cls-14{fill:#e5dfe9;}.cls-15{fill:url(#linear-gradient-11);}.cls-16{fill:url(#linear-gradient-12);}.cls-17{fill:#5c479e;}.cls-18{fill:#aca5b5;}.cls-19{fill:#c0b8cc;}.cls-20{fill:#34254c;}.cls-21{fill:#51347f;}.cls-22{fill:url(#linear-gradient-13);}.cls-23{fill:url(#linear-gradient-14);}.cls-24{fill:url(#linear-gradient-15);}.cls-25{fill:url(#linear-gradient-16);}.cls-26{fill:url(#linear-gradient-17);}.cls-27{fill:url(#linear-gradient-18);}.cls-28{fill:url(#linear-gradient-19);}.cls-29{fill:url(#linear-gradient-20);}.cls-30{fill:url(#linear-gradient-21);}.cls-31{fill:url(#linear-gradient-22);}.cls-32{fill:url(#linear-gradient-23);}.cls-33{fill:url(#linear-gradient-24);}.cls-34{fill:url(#linear-gradient-25);}.cls-35{fill:url(#linear-gradient-26);}.cls-36{fill:#c8b8d3;}.cls-37{fill:url(#linear-gradient-27);}.cls-38{fill:url(#linear-gradient-28);}.cls-39{fill:url(#linear-gradient-29);}.cls-40{fill:url(#linear-gradient-30);}.cls-41{fill:url(#linear-gradient-31);}.cls-42{fill:url(#linear-gradient-32);}.cls-43{fill:url(#linear-gradient-33);}.cls-44{fill:url(#linear-gradient-34);}.cls-45{fill:url(#linear-gradient-35);}.cls-46{fill:#2d2244;}.cls-47{fill:url(#linear-gradient-36);}.cls-48{fill:url(#linear-gradient-37);}.cls-49{fill:url(#linear-gradient-38);}.cls-50{fill:url(#linear-gradient-39);}.cls-51{fill:url(#linear-gradient-40);}.cls-52{fill:url(#linear-gradient-41);}.cls-53{fill:url(#linear-gradient-42);}.cls-54{fill:url(#linear-gradient-43);}.cls-55{fill:url(#linear-gradient-44);}.cls-56{fill:url(#linear-gradient-45);}.cls-57{fill:url(#linear-gradient-46);}.cls-58{fill:url(#linear-gradient-47);}.cls-59{fill:url(#linear-gradient-48);}.cls-60{fill:url(#linear-gradient-49);}.cls-61{fill:url(#linear-gradient-50);}.cls-62{fill:url(#linear-gradient-51);}.cls-63{fill:url(#linear-gradient-52);}.cls-64{fill:url(#linear-gradient-53);}.cls-65{fill:url(#linear-gradient-54);}.cls-66{fill:url(#linear-gradient-55);}.cls-67{fill:url(#linear-gradient-56);}.cls-68{fill:url(#linear-gradient-57);}.cls-69{fill:url(#linear-gradient-58);}.cls-70{fill:url(#linear-gradient-59);}.cls-71{fill:url(#linear-gradient-60);}.cls-72{fill:url(#linear-gradient-61);}.cls-73{fill:url(#linear-gradient-62);}.cls-74{fill:url(#linear-gradient-63);}.cls-75{fill:url(#linear-gradient-64);}.cls-76{fill:url(#linear-gradient-65);}.cls-77{fill:url(#linear-gradient-66);}.cls-78{fill:#988ca5;}.cls-79{fill:url(#linear-gradient-67);}.cls-80{fill:url(#linear-gradient-68);}.cls-81,.cls-82{mix-blend-mode:overlay;}.cls-81{fill:url(#linear-gradient-69);}.cls-82{opacity:0.57;fill:url(#linear-gradient-70);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 172.7,
    y1: 81.84,
    x2: 220.11,
    y2: 81.84,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -10.22, 13.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34254c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51397f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 164.82,
    y1: 136.38,
    x2: 219.94,
    y2: 136.38,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -10.22, 13.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1dae5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7f4f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 148.17,
    y1: 110.91,
    x2: 163.68,
    y2: 110.91,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -10.22, 13.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8b8d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8b8d3",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 146.03,
    y1: 125.78,
    x2: 211.26,
    y2: 125.78,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 169.14,
    y1: 174.96,
    x2: 182.53,
    y2: 174.96,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -10.22, 13.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8b8d3",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8b8d3",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 180.42,
    y1: 147,
    x2: 221.05,
    y2: 147,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 215.67,
    y1: 167.74,
    x2: 233.28,
    y2: 167.74,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 243.9,
    y1: 135.52,
    x2: 228.29,
    y2: 143.72,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -10.22, 13.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 170.72,
    y1: 82.78,
    x2: 181.12,
    y2: 100.05,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 222.74,
    y1: 73.93,
    x2: 213.59,
    y2: 90.17,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 172.08,
    y1: 124.19,
    x2: 212.1,
    y2: 124.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 179.01,
    y1: 125.44,
    x2: 226.13,
    y2: 123.47,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -10.22, 13.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d2244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2c5e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 176.06,
    y1: 81.81,
    x2: 183.94,
    y2: 107.78,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -10.22, 13.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ce1d3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed202e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 210.33,
    y1: 70.11,
    x2: 215.17,
    y2: 92.29,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 182.77,
    y1: 108.8,
    x2: 206.01,
    y2: 107.33,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -10.22, 13.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a193ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cec4d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 199.53,
    y1: 117.35,
    x2: 196.36,
    y2: 92.79,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 183.89,
    y1: 119.9,
    x2: 196.61,
    y2: 108.33,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -10.22, 13.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cec4d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cec4d6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 189.93,
    y1: 114.89,
    x2: 188.25,
    y2: 103.53,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -10.22, 13.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34254c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#432a68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 197.49,
    y1: 113.77,
    x2: 195.81,
    y2: 102.41,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 192.58,
    y1: 110.36,
    x2: 191.76,
    y2: 101.69,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 203.11,
    y1: 104.01,
    x2: 206.06,
    y2: 100.86,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -10.22, 13.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3492b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4cc8e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 204.09,
    y1: 108.97,
    x2: 207.4,
    y2: 108.97,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -10.22, 13.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d733db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f43ef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 204.66,
    y1: 89.84,
    x2: 210.8,
    y2: 88.25,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -10.22, 13.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e45a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2265c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 178.87,
    y1: 94.05,
    x2: 190.43,
    y2: 91.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 181.44,
    y1: 79.27,
    x2: 211.97,
    y2: 79.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 177.78,
    y1: 70.67,
    x2: 174.42,
    y2: 71.51,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 211.98,
    y1: 62.31,
    x2: 214.93,
    y2: 61.7,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 185.32,
    y1: 47.88,
    x2: 195.09,
    y2: 47.88,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 179.32,
    y1: 66.78,
    x2: 212.43,
    y2: 55.63,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 187.86,
    y1: 76.83,
    x2: 196.06,
    y2: 47.76,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -10.22, 13.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8b8d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8b8d3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 187.29,
    y1: 81.4,
    x2: 204.64,
    y2: 77.09,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 177,
    y1: 70.51,
    x2: 217.06,
    y2: 63.36,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -10.22, 13.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#201d21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#524b56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 171.66,
    y1: 69.49,
    x2: 190.38,
    y2: 68.46,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -10.22, 13.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#111011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111011",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 199.18,
    y1: 53.4,
    x2: 204.44,
    y2: 68.85,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -10.22, 13.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ede7f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ede7f2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 206.55,
    y1: 65.37,
    x2: 211.8,
    y2: 72.62,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 217.4,
    y1: 139.82,
    x2: 238.25,
    y2: 139.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 177.66,
    y1: 154.08,
    x2: 156.14,
    y2: 140.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 229.03,
    y1: 106.07,
    x2: 226.82,
    y2: 86.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 164.64,
    y1: 104.08,
    x2: 168.31,
    y2: 104.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 179.09,
    y1: 93.66,
    x2: 190.65,
    y2: 90.82,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 162.52,
    y1: 104.71,
    x2: 143.92,
    y2: 86.25,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 143.89,
    y1: 82.23,
    x2: 149.09,
    y2: 82.23,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 139.91,
    y1: 89.1,
    x2: 145.48,
    y2: 89.1,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 136.57,
    y1: 98.27,
    x2: 144.68,
    y2: 98.27,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 137.05,
    y1: 106.5,
    x2: 147.02,
    y2: 106.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 156.25,
    y1: 86.05,
    x2: 152,
    y2: 101.82,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 168.46,
    y1: 102.01,
    x2: 155.85,
    y2: 92.97,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 160.43,
    y1: 84.1,
    x2: 161.48,
    y2: 78.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 145.21,
    y1: 83.5,
    x2: 149.09,
    y2: 83.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 140.62,
    y1: 89.71,
    x2: 145.43,
    y2: 89.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 140.78,
    y1: 99.57,
    x2: 144.68,
    y2: 99.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 142.26,
    y1: 107.28,
    x2: 147.02,
    y2: 107.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -522.02,
    y1: 119.5,
    x2: -540.63,
    y2: 101.05,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -306.19, 40.87)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -540.66,
    y1: 97.02,
    x2: -535.46,
    y2: 97.02,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -306.19, 40.87)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -544.64,
    y1: 103.89,
    x2: -539.07,
    y2: 103.89,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -306.19, 40.87)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -547.98,
    y1: 113.07,
    x2: -539.87,
    y2: 113.07,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -306.19, 40.87)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -547.5,
    y1: 121.29,
    x2: -537.53,
    y2: 121.29,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -306.19, 40.87)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -528.29,
    y1: 100.85,
    x2: -532.55,
    y2: 116.62,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -306.19, 40.87)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -516.08,
    y1: 116.8,
    x2: -528.7,
    y2: 107.76,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -306.19, 40.87)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -524.12,
    y1: 98.89,
    x2: -523.07,
    y2: 93.11,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -306.19, 40.87)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -539.34,
    y1: 98.3,
    x2: -535.46,
    y2: 98.3,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -306.19, 40.87)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -543.93,
    y1: 104.5,
    x2: -539.12,
    y2: 104.5,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -306.19, 40.87)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -543.77,
    y1: 114.36,
    x2: -539.87,
    y2: 114.36,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -306.19, 40.87)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -542.29,
    y1: 122.07,
    x2: -537.53,
    y2: 122.07,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -306.19, 40.87)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 222.25,
    y1: 176.35,
    x2: 258.89,
    y2: 176.35,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 221.26,
    y1: 200.84,
    x2: 263.83,
    y2: 165.36,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -10.22, 13.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbaec4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ded1e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -1586.83,
    y1: 763.62,
    x2: -1550.19,
    y2: 763.62,
    gradientTransform: "matrix(-0.82, 0.57, 0.57, 0.82, -1564.87, 471.26)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 132.8,
    y1: 202.17,
    x2: 182.89,
    y2: 195.07,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 251.25,
    y1: 102.06,
    x2: 147.06,
    y2: 174.04,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -10.22, 13.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04074a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 241.87,
    y1: 98.45,
    x2: 138.44,
    y2: 195.44,
    gradientTransform: "matrix(1, -0.07, 0.07, 1, -10.22, 13.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04074a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04074a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.7,30.54H31V68.39Q35.63,62.65,44.27,59a46.68,46.68,0,0,1,18.36-3.65q17.71,0,29,7.75A44.83,44.83,0,0,1,108,82.89a65.66,65.66,0,0,1,5.09,25.78q0,25.46-14.5,41T57.32,165.11q-25.23,0-40.28-12.61t-17-33H30.1a23.79,23.79,0,0,0,9,14.16Q46,139,56.88,139q13.07,0,19.7-8.19t6.64-21.7q0-13.71-6.75-20.91T56.66,81q-9.3,0-15.49,4.64a25.33,25.33,0,0,0-8.85,12.4H2.66V3.32h100Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M150.61,22.35Q164.44.68,196.54.66t45.93,21.69q13.83,21.71,13.83,60,0,38.52-13.83,60.43t-45.93,21.91q-32.08,0-45.93-21.91T136.78,82.33Q136.78,44.05,150.61,22.35Zm73,32.43q-2.1-11.18-8.41-18.26t-18.7-7.08q-12.39,0-18.7,7.08t-8.41,18.26a151.44,151.44,0,0,0-2.11,27.55,167.33,167.33,0,0,0,2,28.22q2,11.4,8.41,18.37t18.81,7q12.39,0,18.81-7t8.41-18.37a167.33,167.33,0,0,0,2-28.22A152.35,152.35,0,0,0,223.65,54.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295.81,12.06Q310.3,0,334,0q16.17,0,27.67,5.64T379,20.92a41.12,41.12,0,0,1,5.86,21.8q0,13.94-7.19,23.57T360.55,79.23v.89a37.26,37.26,0,0,1,20,14.17q7.19,10.17,7.19,26.11a46,46,0,0,1-6.09,23.68,41.38,41.38,0,0,1-17.93,16.27q-11.83,5.86-28.44,5.87-25,0-40.72-12.62T278,116.42h30.1q.44,10.85,7.41,17.37t19.15,6.53q11.3,0,17.37-6.31t6.09-16.27q0-13.26-8.41-19T323.58,93h-6.42V67.5h6.42q31.43,0,31.43-21,0-9.51-5.64-14.83T333.1,26.34q-10.41,0-16.05,5.64a22.75,22.75,0,0,0-6.52,14.28H280.2Q281.31,24.12,295.81,12.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.68,92.84s-2.68-8.15-1.81-9.31,12.7-6.32,27.81-9.52,15.82-2,17-1.13,2.59,10.1,2.56,12S169.68,92.84,169.68,92.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M241.24,154.63l-1.05,2.31-7.33,16.15-7,15.47c-3.49-2.45-4.57-11.39-4.41-18.2a54.55,54.55,0,0,0-.77-11.32,15,15,0,0,1-5.14-4.55,27.21,27.21,0,0,1-2.07-3.21h0c-.44-.82-.68-1.35-.68-1.35-8.19.4-13.77-4.91-15.09-5.77s-3.8,0-6.27,5.49c-2.22,5-7.84,7-8.95,7.36l-.18.06c-.24,1.34-.49,2.54-.76,3.64-2.09,8.83-4.64,10-4.64,10-.28,2.86,1.43,7,2,12.35a106.62,106.62,0,0,1,0,13.59l-7.37-4.57-14.42-9s-5.46-12.9-5.12-17.19a12,12,0,0,1,.73-3.26,15.55,15.55,0,0,1,1.39-2.83h0a12,12,0,0,1,1-1.4s0-.68,0-1.76c0-.48,0-1,.08-1.65a32.2,32.2,0,0,1,.63-4.54,8.62,8.62,0,0,1,.33-1.16,12.66,12.66,0,0,1,.83-1.9,15.64,15.64,0,0,1,1-1.56h0l0,0,0,0v0h0l0-.05a1,1,0,0,1,.08-.11l.08-.11.28-.35a12.88,12.88,0,0,1,1.11-1.23h0s.32-1.13.76-2.75c.34-1.25.75-2.79,1.12-4.34.87-3.53.78-4.79,3-6.52s2.76-3.15,4.07-4.18h0l.06-.05c.76-.58,2.15-1.46,3.22-2.11h0l1.47-.89a14.09,14.09,0,0,1,.79-4.63,5.88,5.88,0,0,1-.63-1.5c-.22-.67-.35-1.28-.35-1.28-.37.25-.73.47-1.07.67h0c-3.82,2.17-6.52,1.43-6.52,1.43a14.77,14.77,0,0,1-3,.91,13.82,13.82,0,0,1-3.87.19,18.79,18.79,0,0,1-10.79-5.27l3.33-4.71,7.34-10.4a8.64,8.64,0,0,1,2.93,1h0a4.73,4.73,0,0,1,.6.42h0l.26.23a3,3,0,0,1,.62.78h0l0,.05h0c0-.24.06-.46.1-.67a4.41,4.41,0,0,1,.43-1.26l.12-.2a2.7,2.7,0,0,1,.67-.76,2.07,2.07,0,0,1,.83-.4c0-.21,0-.42.07-.62,1.05-7.67,6-7.85,6-7.85,1-5.76,6.87-5.85,6.87-5.85s1.24.29,3.19.57h0a39.93,39.93,0,0,0,12.64-.07,17.51,17.51,0,0,0,9.71-5.39,11,11,0,0,0,1.05-1.35c4.83-1.12,8.56,5,8.56,5,2.77,0,5,1.85,6.25,3.22a12.88,12.88,0,0,1,1.19,1.49l.09-.12a8,8,0,0,1,1-1.06h0l0,0h0l.19-.16h0a10,10,0,0,1,1.79-1.11,10.92,10.92,0,0,1,2.79-.93l6.5,13.47,1.41,2.91a10.07,10.07,0,0,1-5.33,6.51,12.08,12.08,0,0,1-1.3.58,9,9,0,0,1-1,.3c-3.65.85-7.67-.78-9.95-2h0l-.09,0-.06,0-.14-.08c-1-.53-1.58-.93-1.58-.93a11.46,11.46,0,0,1,.54,2h0c0,.13.05.26.07.39a23.19,23.19,0,0,1,.11,6,19.19,19.19,0,0,1,1.13,4.56,4.42,4.42,0,0,1-.41,2.92l0,.06a1.69,1.69,0,0,1,.37-.2h0a7.18,7.18,0,0,1,1.28-.43l.26-.06h0c.31-.06.67-.11,1.06-.15h0a13.65,13.65,0,0,1,5.63.83h0l.18.07.34.12c6,2.28,8.55,11.9,8.55,11.9a10.53,10.53,0,0,1,2.67,2.81,17.89,17.89,0,0,1,3.15,8.34C240.52,148.83,241.24,154.63,241.24,154.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M158.65,118.85a18.79,18.79,0,0,1-10.79-5.27l3.33-4.71a13.66,13.66,0,0,0,7.12,4.94,10.43,10.43,0,0,0,3.32.3A16.47,16.47,0,0,1,158.65,118.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M212.74,119.27l-5,7.59s-4.42,7.12-12.68,6.42-15.74-8.25-21.67-4.84S164,139.51,164,139.51l3.4-1s-6,4-7.06,6.47a1.14,1.14,0,0,0,.17,1.43l-3.61,1.06a15.64,15.64,0,0,1,1-1.56h0l0,0,0,0v0h0l0-.05a1,1,0,0,1,.08-.11l.08-.11.28-.35a12.88,12.88,0,0,1,1.11-1.23h0s.32-1.13.76-2.75c.34-1.25.75-2.79,1.12-4.34.87-3.53.78-4.79,3-6.52s2.76-3.15,4.07-4.18h0l.06-.05c.76-.58,2.15-1.46,3.22-2.11h0l1.47-.89a14.09,14.09,0,0,1,.79-4.63,5.88,5.88,0,0,1-.63-1.5c-.22-.67-.35-1.28-.35-1.28-.37.25-.73.47-1.07.67h0c-3.82,2.17-6.52,1.43-6.52,1.43a14.77,14.77,0,0,1-3,.91,17.5,17.5,0,0,0,1.84-5.18,7.54,7.54,0,0,0,2.07-1.17,4.11,4.11,0,0,0,3.56,1.18c2.52-.17,7.42-2.4,7.4-5.09a17.69,17.69,0,0,0,12.05,12.14C199.45,123.65,208.58,120.82,212.74,119.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M176.89,170.72c-.28,2.86,1.43,7,2,12.35a106.62,106.62,0,0,1,0,13.59l-7.37-4.57c1.72-4.69-.51-11.76-.74-17-.28-6.46,3.65-6.73,3.65-6.73a10.9,10.9,0,0,1,3.37-12.1,22.37,22.37,0,0,1,3.8,4.45C179.44,169.54,176.89,170.72,176.89,170.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M216.56,144a25.77,25.77,0,0,0-3.1,7.24c-.44-.82-.68-1.35-.68-1.35-8.19.4-13.77-4.91-15.09-5.77s-3.8,0-6.27,5.49c-2.22,5-7.84,7-8.95,7.36-.46-.6-1.25-1.58-2.29-2.72,1.94-1.92,3.55-4.65,6.21-8.88a14.47,14.47,0,0,1,10-7c3.42-.71,5,1.4,12.81,4.81A12.15,12.15,0,0,0,216.56,144Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M232.86,173.09l-7,15.47c-3.49-2.45-4.57-11.39-4.41-18.2a54.55,54.55,0,0,0-.77-11.32,15,15,0,0,1-5.14-4.55,60.8,60.8,0,0,1,6.69-10.84c-1.12,4.56,1.09,8.09,3.7,11.23A45.83,45.83,0,0,0,226.5,168C227.38,171.91,230.67,172.89,232.86,173.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M241.24,154.63l-1.05,2.31c-2-2.21-3.7-6.88-4.6-13.31-1.23-8.76-6.64-10-6.64-10,2.14-7-2.75-12.65-3.68-13.64l.34.12c6,2.28,8.55,11.9,8.55,11.9a10.53,10.53,0,0,1,2.67,2.81,17.89,17.89,0,0,1,3.15,8.34C240.52,148.83,241.24,154.63,241.24,154.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M174.91,88.34c.53,3.13,5.75,3.24,5.75,3.24-3.25,1-5.95.73-9.31.16s-5.64,5.45-4.73,5.83a5.4,5.4,0,0,1,1.78,2c-2.61-1.24-3,0-2.17,2.84a24.41,24.41,0,0,1,.48,7.08c-.51-2.9-2.42-6.82-3.64-9.13a4.41,4.41,0,0,1,.43-1.26l.12-.2a2.7,2.7,0,0,1,.67-.76,2.07,2.07,0,0,1,.83-.4c0-.21,0-.42.07-.62,1.05-7.67,6-7.85,6-7.85,1-5.76,6.87-5.85,6.87-5.85s1.24.29,3.19.57C178.84,83.64,174.38,85.22,174.91,88.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M220.74,86.68l-.12.6a10.59,10.59,0,0,0-8.37-3.07c-.6,2.73-5.31,3.21-5.31,3.21s3.65-2,3.18-4.33-6.47-4.46-6.47-4.46a.58.58,0,0,1-.05-.14,11,11,0,0,0,1.05-1.35c4.83-1.12,8.56,5,8.56,5,2.77,0,5,1.85,6.25,3.22a12.88,12.88,0,0,1,1.19,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M158.93,150.77c-.11.26-3.69,8.88-6.29,11.91h0a15.55,15.55,0,0,1,1.39-2.83h0a12,12,0,0,1,1-1.4s0-.68,0-1.76c0-.48,0-1,.08-1.65A12.18,12.18,0,0,0,158.93,150.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M224.18,102.69a26.63,26.63,0,0,0,2.67,4.47c-3.65.85-7.67-.78-9.95-2h0l-.09,0-.06,0-.14-.08c-1-.53-1.58-.93-1.58-.93a11.46,11.46,0,0,1,.54,2h0c0,.13.05.26.07.39-4.7-6.52-6.78-15.08-6.88-15.49.15.41,3.15,8.85,10.4,11.13A13,13,0,0,0,224.18,102.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M234.49,99.77a10.07,10.07,0,0,1-5.33,6.51,24.79,24.79,0,0,1-2.51-4.11,12.71,12.71,0,0,0,6.43-5.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M218.09,119.33h0s-6.71,3.77-7.79,5-2,3-7.17,4.63a35.69,35.69,0,0,1-4.36,1c-4.49.76-10.08.79-14.66-1.79a13.07,13.07,0,0,0-5.86-4.86,46.17,46.17,0,0,0,6.07.94l.57,0c.3,0,.59,0,.85,0a2.94,2.94,0,0,1,1-.86,15.93,15.93,0,0,1,3.8-.22h.73c1.07,0,2.26-.06,3.5-.16s2.17-.22,3.14-.35l.73-.1c1.73-.25,3-.49,3.34-.51a2.63,2.63,0,0,1,1.81.68l.14.13.48-.17c.58-.21,1.63-.6,2.91-1.1l.55-.22,1.14-.46.41-.17h0c1-.4,2-.85,3-1.3l.31-.15a28.08,28.08,0,0,0,4.13-2.31c0,.24,0,.46,0,.66a3.68,3.68,0,0,1-.45,2.26l0,.06a1.69,1.69,0,0,1,.37-.2h0A7.18,7.18,0,0,1,218.09,119.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M216.92,117.65c-1.65,1-7.62,4.53-12.41,5.74l-.08,2.11c0-.23-.06-2.63-5-1.85a76.09,76.09,0,0,1-10.22.86s1.39,6.11,9.54,5.46c-4.49.76-10.08.79-14.66-1.79a13.07,13.07,0,0,0-5.86-4.86,46.17,46.17,0,0,0,6.07.94l.57,0c.3,0,.59,0,.85,0a2.94,2.94,0,0,1,1-.86,15.93,15.93,0,0,1,3.8-.22h.73c1.07,0,2.26-.06,3.5-.16s2.17-.22,3.14-.35l.73-.1c1.73-.25,3-.49,3.34-.51a2.63,2.63,0,0,1,1.81.68l.14.13.48-.17c.58-.21,1.63-.6,2.91-1.1l.55-.22,1.14-.46.41-.17h0c1-.4,2-.85,3-1.3l.31-.15a28.08,28.08,0,0,0,4.13-2.31C216.9,117.23,216.91,117.45,216.92,117.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M191.32,123.18v6.56l-.74-6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M198.69,122.57l-.28,6.69-.45-6.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M184.89,124.29l-.38,2.75-.19-2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M204.14,127.6c0-1.9-.2-3.87-.3-4.86l.14.13.48-.17A19.38,19.38,0,0,1,204.14,127.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M207.92,121.38l-.29,4.09-.26-3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M209.47,120.75l-.21,3-.2-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M212.75,119.3l-.16,2.35-.15-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M189,130.53c-3.41,1-7.43-6.92-14-6.31a21.73,21.73,0,0,0-6.42,1.9l.06-.05c.76-.58,2.15-1.46,3.22-2.11h0a12.83,12.83,0,0,1,5.75-.7C182.37,123.5,185.66,130.13,189,130.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M225.08,119.94C215.8,118.77,207,128,207,128c3.82-4.95,7.19-7.15,9.45-8.13l.33-.14h0a11.84,11.84,0,0,1,1.54-.49h0a4.91,4.91,0,0,1,1.06-.15h0A13.65,13.65,0,0,1,225.08,119.94Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "157.9 145.88 157.9 145.88 157.9 145.88 157.9 145.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M167.42,138.49a24.48,24.48,0,0,0-9.48,7.34,14,14,0,0,1,1.64-1.91s.32-1.13.76-2.75A36.27,36.27,0,0,1,167.42,138.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M157,154.69a18.53,18.53,0,0,1-3,5.16,12,12,0,0,1,1-1.4s0-.68,0-1.76A6.55,6.55,0,0,0,157,154.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M221.77,85.62c-.35.33-3.33,3.33-2.42,12.33,0,0-1.9-6.74.11-12.64a12.88,12.88,0,0,1,1.19,1.49A7.42,7.42,0,0,1,221.77,85.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M221.79,85.61h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M163,101a6.67,6.67,0,0,0-.88-1A3.26,3.26,0,0,1,163,101Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M166.71,109.45c-1.44-4.64-2.77-7.13-3.74-8.45h0a5.13,5.13,0,0,1,.53-1.93A35.08,35.08,0,0,1,166.71,109.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M168.37,99.06a4.17,4.17,0,0,0-4.08-1,2.07,2.07,0,0,1,.83-.4c0-.21,0-.42.07-.62A5,5,0,0,1,168.37,99.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M177.5,112.51a39.21,39.21,0,0,1-4,4.42c-.22-.67-.35-1.28-.35-1.28C172.77,115.9,177.5,112.51,177.5,112.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M215,104.1a11.46,11.46,0,0,1,.54,2,14.91,14.91,0,0,1-2.85-5.19,10.22,10.22,0,0,0,3.89,4.17C215.62,104.5,215,104.1,215,104.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M182.09,116l1.5,2.22c-2.4,1.91-6.65,4.41-9,4.73s-3.8-.06-4.05-1.46c-.2-1.07,1.7-2.9,2.61-3.72.29-.26.49-.41.49-.41l.48,1s-2.78,2.86-.91,3.2l.19,0c2.24.18,8.61-5.82,8.61-5.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M173.21,121.63h0s-1.71.14-1.64-1.13a6.47,6.47,0,0,1,1.58-2.7c.29-.26.49-.41.49-.41l.48,1S171.34,121.29,173.21,121.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M220.76,113.75a6.94,6.94,0,0,1-2.41,2c-3,1.69-9.15.3-9.15.3l-.69-3.27a16.88,16.88,0,0,0,7.87,1.84,7.41,7.41,0,0,0,2.1-.41c1.35-.5,1.6-1.33,1.22-1.88-.53-.75-3.92-.16-3.92-.16l.09-2.74a15.63,15.63,0,0,1,3,.49,3.34,3.34,0,0,1,1.88,1.08A2.29,2.29,0,0,1,220.76,113.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M220.76,113.75a3.29,3.29,0,0,1-2.28.44c2.57-.77,1-3.35.35-4.29a3.34,3.34,0,0,1,1.88,1.08A2.29,2.29,0,0,1,220.76,113.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M176.2,80.79s-4.66,2.09-4.11,12.48,9.14,15.82,9.14,15.82l.15,2.2s-6.63-2.07-10.36-10.51-.82-18.92,5-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M204.43,73.68s6,2.28,8.61,10.48-2.06,13.89-6.71,17.53l1.5,3.53s8.2-5,9-13.73-5.26-16.87-11.34-20.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M209.46,117.44c0,.47-4.16,1.19-5.76,1.48a176.41,176.41,0,0,1-19.8,2.47.53.53,0,0,1-.54-.36,93.46,93.46,0,0,1-3.51-16.13c-.2-1.63-.37-3.26-.5-4.91a1.09,1.09,0,0,1,.79-1.13,95.28,95.28,0,0,1,26-3.86,1.1,1.1,0,0,1,1.07.85C208.59,102.15,209.69,114,209.46,117.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M209.2,116c0,.48-4.15,1.19-5.75,1.49a179.07,179.07,0,0,1-19.8,2.47.53.53,0,0,1-.54-.37,91.43,91.43,0,0,1-3.51-16.13c-.21-1.62-.37-3.26-.51-4.9a1.08,1.08,0,0,1,.79-1.13,95.76,95.76,0,0,1,26-3.87,1.09,1.09,0,0,1,1.06.86C208.34,100.74,209.44,112.54,209.2,116Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M203.45,117.52A176.57,176.57,0,0,1,183.92,120a.86.86,0,0,1-.89-.61,92.27,92.27,0,0,1-3.43-15.87C183,109.43,190.58,118.87,203.45,117.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M182.79,101.87s1.42,9.23,2.88,14.5l1.88-.28s-1.57-9.22-2-14.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M190.42,100.24s1.32,10,2.6,14.84l2.19-.3s-1.59-9.38-2-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M187.08,102.21s.39,3.45.87,5.79l1.88-.29-.87-5.79A12.27,12.27,0,0,0,187.08,102.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M203,101.52a1.66,1.66,0,1,1-1.77-1.54A1.66,1.66,0,0,1,203,101.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M204.11,108.56a1.65,1.65,0,1,1-1.76-1.54A1.66,1.66,0,0,1,204.11,108.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M207.46,88.1a3.39,3.39,0,1,1-3.62-3.16A3.4,3.4,0,0,1,207.46,88.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M178.54,96.51c1.55-.35,5.31-1.11,9.42-2a1,1,0,0,0,.8-1.33L188,90.58a.8.8,0,0,0-.91-.63c-1.86.31-6.67.62-9.64,1.62-.37.12-.77.21-.55,1.42a22,22,0,0,0,.73,3A.79.79,0,0,0,178.54,96.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M176.2,80.79a16.05,16.05,0,0,0,1.61,3.72s16.16,7.43,28.74-7.34a20.2,20.2,0,0,0-1.91-4.93S197.08,84.71,176.2,80.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M170.06,65.91s-3.19,1.8-3.65,2.14c-1,.75,2.86,11.52,4.27,11.57a19.24,19.24,0,0,0,3.72-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M169,69.14a.63.63,0,0,1-.59.67.62.62,0,0,1-.67-.58.63.63,0,0,1,1.26-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M202.52,55.56s3.63-.46,4.2-.46c1.24,0,4.6,10.94,3.49,11.82a18.69,18.69,0,0,1-3.58,1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M205.29,57.53a.63.63,0,0,0,.87.19.63.63,0,1,0-.69-1.06A.63.63,0,0,0,205.29,57.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M178.35,50.86l-.39-1.3a14.7,14.7,0,0,1,9-2.82l.75,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M207,70.34l-7.91,2.55-23.8,7.68c-9.22-10-7-26.23,5.14-31.18.57-.23,1.13-.43,1.69-.6h0C195.55,44.57,208.12,55.1,207,70.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M199.13,72.89l-23.8,7.68c-9.22-10-7-26.23,5.14-31.18.57-.23,1.13-.43,1.69-.6-8.14,3.38-8.87,8.84-1.59,6.6a24.52,24.52,0,0,1,12.5-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M207,70.34A19.52,19.52,0,0,1,192.73,83c-11.52,2.68-17.4-2.45-17.4-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M207,70.34a24.21,24.21,0,0,1-6.88,7c-5.1,3.49-13.2,6.38-24.83,3.23-5.06-9.51-2.13-19.12,5-23.7a16.26,16.26,0,0,1,1.69-.94C190.85,51.62,204.1,55.05,207,70.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M200.16,77.34c-5.1,3.49-13.2,6.38-24.83,3.23-5.06-9.51-2.13-19.12,5-23.7-.91,2.24-2.11,6.75-1.11,13.63,1.49,10.33,8.64,13.42,20.93,6.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M186.93,55.91s9.85-1.69,15.35,7.38a1.61,1.61,0,0,1-.44,2.15h0a1.61,1.61,0,0,1-2.33-.52A18.63,18.63,0,0,0,186.93,55.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M203.91,67.5a1.26,1.26,0,1,1-1.72-.46A1.26,1.26,0,0,1,203.91,67.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M224.27,141.17a18.72,18.72,0,0,1-2.05,2.48h0a60.8,60.8,0,0,0-6.69,10.84,27.21,27.21,0,0,1-2.07-3.21h0a25.77,25.77,0,0,1,3.1-7.24A28.78,28.78,0,0,0,224.27,141.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M236.83,134.84a23.21,23.21,0,0,0-14.61,8.81A13.51,13.51,0,0,0,224,141.5a29.86,29.86,0,0,1-7.42,2.54,29.67,29.67,0,0,1,3-4c5.43-6.22,14.63-8,14.63-8A10.53,10.53,0,0,1,236.83,134.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M182.47,157l-.18.06c-.24,1.34-.49,2.54-.76,3.64a22.37,22.37,0,0,0-3.8-4.45c.22-.19.45-.35.67-.51a11.82,11.82,0,0,0,1.78-1.46C181.22,155.43,182,156.41,182.47,157Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M180.18,154.29a11.82,11.82,0,0,1-1.78,1.46c-.22.16-.45.32-.67.51a32.75,32.75,0,0,0-6.24-4.46,21.39,21.39,0,0,0-15.4-2.46,12.66,12.66,0,0,1,.83-1.9,15.64,15.64,0,0,1,1-1.56h0l0,0,0,0v0h0l0-.05a1,1,0,0,1,.08-.11l.08-.11.28-.35c.55-.08,1.19-.16,1.9-.2a20.9,20.9,0,0,1,10.15,1.7A32.32,32.32,0,0,1,180.18,154.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M229.16,106.28a12.08,12.08,0,0,1-1.3.58,9,9,0,0,1-1,.3,26.63,26.63,0,0,1-2.67-4.47,10.5,10.5,0,0,0,2.47-.52A24.79,24.79,0,0,0,229.16,106.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M226.65,102.17a10.5,10.5,0,0,1-2.47.52A29.44,29.44,0,0,1,222,85.43h0a10,10,0,0,1,1.79-1.11,31.39,31.39,0,0,0,1.67,15.11C225.85,100.44,226.25,101.35,226.65,102.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M164.36,113.48a17.5,17.5,0,0,1-1.84,5.18,13.82,13.82,0,0,1-3.87.19,16.47,16.47,0,0,0,3-4.74A9.72,9.72,0,0,0,164.36,113.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M164.36,113.48a9.72,9.72,0,0,1-2.73.63c2.31-5.64,1.26-11.61.7-13.93a3,3,0,0,1,.62.78h0l0,.05h0a5.13,5.13,0,0,1,.53-1.93l.12-.2C165.17,105.27,165,110.07,164.36,113.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M178.65,95.87c1.55-.35,5.49-1.25,9.42-2a.8.8,0,0,0,.64-1l-.62-3a.81.81,0,0,0-.92-.63,74.83,74.83,0,0,0-9.65,2.15.8.8,0,0,0-.54.89,22,22,0,0,0,.73,3A.79.79,0,0,0,178.65,95.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M153.49,112.56a12.62,12.62,0,0,1-4.5.87,12,12,0,0,1-5.32-1.15,1.59,1.59,0,0,1-.62.56h0a6.56,6.56,0,0,1-4,.4c-4-.52-5.4-2.64-5.35-4.22a1.29,1.29,0,0,1,.68-1h0a8.86,8.86,0,0,1,3.61-.82c1.1-.07,1.4-.41.87-1.16l-.09-.11c-.67-.65-2.87-.68-4.12-1.35a4.51,4.51,0,0,1-2-4.13c0-.85.79-1.34,1.83-1.5a6.56,6.56,0,0,1,3.48.51c2.12,1,2.88.59,3-.52,0-.79-1.58-1.86-3.07-2.88-.61-.43-1.2-.84-1.64-1.22-1.51-1.32-.59-4.07,2.06-4.57a2,2,0,0,1,.78,0h0c2.08.4,3,4,4.2,3.45s.35-1.76-1.52-3.69c-.24-.25-.5-.52-.74-.82-1.63-1.93-3.05-4.56-1.22-5.92a1.88,1.88,0,0,1,1.52-.29c2.32.42,5.62,3.91,7.55,8.21a20.41,20.41,0,0,0,1.67,3.13c.73,1,1.07.9,1.21.74a.41.41,0,0,0,.07-.12c.5-.75.81-5.51,1.08-8.53,0-.49.1-1,.17-1.42.37-2.34,1.15-4.1,2.59-4.46a3.1,3.1,0,0,1,.7-.1c1.25,0,1.91,1,2.21,3.38a10,10,0,0,1,.05,1.72c-.13,2-.81,3.87-.78,6.23.05,3,1.85,6.2,2.43,10.11S158.87,110.46,153.49,112.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M144.18,87.43c-.2,1.7-2,1.83-3.25,1.72-.18-.21-.36-.43-.52-.65-1.38-1.84-2.33-4-.7-5.27a1.88,1.88,0,0,1,1.52-.29c.5.61,1.51,1.38,2.22,2.32A3,3,0,0,1,144.18,87.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M141,93.81A2.8,2.8,0,0,1,137.79,96c-.51-.36-1-.71-1.42-1l-.22-.18c-1.51-1.32-.59-4.07,2.06-4.57a2,2,0,0,1,.78,0h0a12.78,12.78,0,0,1,1.54,2h0A2.23,2.23,0,0,1,141,93.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M139.6,105.92a2.55,2.55,0,0,1-.88,0l-1.47-.36a11.67,11.67,0,0,1-2.65-1,4.51,4.51,0,0,1-2-4.13c0-.85.79-1.34,1.83-1.5a11.26,11.26,0,0,0,3,2c.28.1.59.23.89.37,1.22.55,2.41,1.33,2.59,2.08C141.06,104.24,141,105.67,139.6,105.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M143.05,112.84h0a6,6,0,0,1-3.49.46l-.56-.06c-4-.52-5.4-2.64-5.35-4.22a1.29,1.29,0,0,1,.68-1h0c.09,0,1.69-.63,5.47,1l.33.14C143.76,110.61,144.64,111.69,143.05,112.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M149.12,105.35c-.1-.2-3.11-6,1.33-11.07.73,1,1.07.9,1.21.74l.09.19S147.58,101.18,149.12,105.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M153.49,112.56a12.62,12.62,0,0,1-4.5.87c9.69-2.21,8.47-11.28,7.31-14.1a17.5,17.5,0,0,1,.09-12.49c1.28-3.46.43-5.57-.12-6.45,1.25,0,1.91,1,2.21,3.38a10,10,0,0,1,.05,1.72c-.13,2-.81,3.87-.78,6.23.05,3,1.85,6.2,2.43,10.11S158.87,110.46,153.49,112.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M158.53,85.49A5.6,5.6,0,0,1,153,85c.37-2.34,1.15-4.1,2.59-4.46,1.71-.43,2.56.46,2.91,3.28A10,10,0,0,1,158.53,85.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M144.18,87.43c-.2,1.7-3.38,2.52-3.77,1.07.31-3.13,2.09-3.36,3-3.24A3,3,0,0,1,144.18,87.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M141,93.81c-.07,2.53-3.67,2.86-4.61,1.15a2.58,2.58,0,0,1,.41-2.6c1.56-2,3.66-.25,3.75-.18h0A3,3,0,0,1,141,93.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M139.6,105.92a2.55,2.55,0,0,1-.88,0l-1.47-.36a4.24,4.24,0,0,1,1-4.28c1.22.55,2.41,1.33,2.59,2.08C141.06,104.24,141,105.67,139.6,105.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M143.05,112.84h0a6,6,0,0,1-3.49.46,3.37,3.37,0,0,1-.42-2.6,3,3,0,0,1,1-1.65C143.76,110.61,144.64,111.69,143.05,112.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M232.74,101.64a12.34,12.34,0,0,0,4.58,0,12,12,0,0,0,5-2.11,1.48,1.48,0,0,0,.71.43h0a6.56,6.56,0,0,0,4.05-.37c3.82-1.25,4.81-3.59,4.47-5.14a1.29,1.29,0,0,0-.86-.9h0a8.72,8.72,0,0,0-3.7-.14c-1.1.13-1.45-.14-1.07-1a.75.75,0,0,1,.07-.12c.53-.77,2.69-1.21,3.79-2.09A4.52,4.52,0,0,0,251,85.8c-.18-.84-1-1.18-2.07-1.14a6.48,6.48,0,0,0-3.33,1.15c-1.9,1.33-2.72,1.11-3,0-.2-.77,1.2-2.12,2.47-3.41a18,18,0,0,0,1.39-1.5c1.24-1.58-.17-4.11-2.87-4.1a2.07,2.07,0,0,0-.77.14h0c-2,.78-2.17,4.44-3.48,4.17-1.47-.3-.68-1.66.8-3.9.2-.3.39-.61.58-1,1.24-2.2,2.15-5,.1-6a1.9,1.9,0,0,0-1.55,0c-2.2.84-4.8,4.89-5.9,9.47a19.26,19.26,0,0,1-1.06,3.39c-.52,1.15-.88,1.08-1,1a.44.44,0,0,1-.09-.1c-.64-.64-1.82-5.27-2.65-8.18-.13-.48-.28-.93-.43-1.36-.8-2.23-1.9-3.82-3.37-3.91a4.11,4.11,0,0,0-.72,0c-1.22.21-1.69,1.32-1.53,3.74a8.92,8.92,0,0,0,.26,1.69c.51,2,1.52,3.66,1.92,6,.52,3-.66,6.43-.5,10.38S227.06,100.57,232.74,101.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M237.21,75.22c.51,1.63,2.35,1.41,3.52,1.08.14-.24.27-.48.39-.74,1-2.06,1.53-4.41-.29-5.3a1.9,1.9,0,0,0-1.55,0c-.38.7-1.23,1.65-1.75,2.69A3.05,3.05,0,0,0,237.21,75.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M241.54,80.89a2.79,2.79,0,0,0,3.54,1.55c.44-.44.87-.88,1.21-1.28l.18-.22c1.24-1.58-.17-4.11-2.87-4.1a2.07,2.07,0,0,0-.77.14h0a12.2,12.2,0,0,0-1.15,2.22h0A2.26,2.26,0,0,0,241.54,80.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M245.16,92.53a2.85,2.85,0,0,0,.85-.21l1.37-.63a12.16,12.16,0,0,0,2.42-1.46A4.52,4.52,0,0,0,251,85.8c-.18-.84-1-1.18-2.07-1.14a11.93,11.93,0,0,1-2.53,2.48,9.33,9.33,0,0,0-.81.53c-1.1.77-2.13,1.76-2.16,2.52C243.4,91.15,243.73,92.54,245.16,92.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M243.05,100h0a6,6,0,0,0,3.51-.2c.17,0,.35-.1.54-.17,3.82-1.25,4.81-3.59,4.47-5.14a1.29,1.29,0,0,0-.86-.9h0c-.1,0-1.78-.31-5.2,2l-.3.2C241.94,97.91,241.27,99.14,243.05,100Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M235.69,93.74c.07-.21,1.94-6.49-3.37-10.63-.52,1.15-.88,1.08-1,1l-.06.21S236.43,89.36,235.69,93.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M232.74,101.64a12.34,12.34,0,0,0,4.58,0c-9.93-.36-10.41-9.51-9.8-12.49A17.52,17.52,0,0,0,225.1,76.9c-1.89-3.16-1.45-5.39-1.08-6.36-1.22.21-1.69,1.32-1.53,3.74a8.92,8.92,0,0,0,.26,1.69c.51,2,1.52,3.66,1.92,6,.52,3-.66,6.43-.5,10.38S227.06,100.57,232.74,101.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M222.75,76a5.61,5.61,0,0,0,5.36-1.55c-.8-2.23-1.9-3.82-3.37-3.91-1.76-.1-2.43.93-2.25,3.77A8.92,8.92,0,0,0,222.75,76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M237.21,75.22c.51,1.63,3.79,1.85,3.91.34-.89-3-2.68-2.91-3.59-2.62A3.05,3.05,0,0,0,237.21,75.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M241.54,80.89c.54,2.47,4.15,2.13,4.75.27a2.59,2.59,0,0,0-.88-2.48c-1.91-1.63-3.66.44-3.73.52h0A3,3,0,0,0,241.54,80.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M245.16,92.53a2.85,2.85,0,0,0,.85-.21l1.37-.63a4.25,4.25,0,0,0-1.77-4c-1.1.77-2.13,1.76-2.16,2.52C243.4,91.15,243.73,92.54,245.16,92.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M243.05,100h0a6,6,0,0,0,3.51-.2,3.35,3.35,0,0,0-.07-2.63,2.91,2.91,0,0,0-1.29-1.43C241.94,97.91,241.27,99.14,243.05,100Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M224.5,189.1s-1.38-4.55-1.07-6.94,14-35.73,31.87-35.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M228.72,200.61s-4-3.18-4.36-13.68,21-47,34-39.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M261.73,160.62c0,.43,0,.86,0,1.31a64.74,64.74,0,0,1-.66,7c-.06.42-.12.84-.19,1.26-.36,2.18-.83,4.46-1.44,6.82-.1.4-.21.81-.32,1.22a83.87,83.87,0,0,1-2.67,8.09c-.15.39-.3.78-.46,1.18-.94,2.33-2,4.7-3.24,7.09-.19.38-.39.76-.59,1.14-1.09,2-2.28,4.1-3.59,6.15l-.33.51h0q-.41.24-.81.45c-9.47,5-20.88-1.49-20.92-6.25v-.15a11.3,11.3,0,0,1,.17-1.27c.27-1.51.85-3.89,1.66-6.75.12-.39.23-.8.36-1.21.66-2.26,1.45-4.77,2.34-7.36l.42-1.19c.93-2.67,2-5.38,3-8l.49-1.17c1-2.26,2-4.41,3-6.33.2-.38.41-.76.62-1.13s.51-.86.76-1.27a52.31,52.31,0,0,1,3.29-4.74l.85-1.06A31.66,31.66,0,0,1,250,149a15.14,15.14,0,0,1,1.46-.87c2.59-1.41,5-1.78,6.86-1,.93.37,1.76,1.72,2.37,3.84.13.45.24.92.35,1.43A39.28,39.28,0,0,1,261.73,160.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M261.06,152.33,250,149a15.14,15.14,0,0,1,1.46-.87l9.23,2.82C260.84,151.35,261,151.82,261.06,152.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M261.73,160.62c0,.43,0,.86,0,1.31l-19-5.83.85-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M261,169c-.06.42-.12.84-.19,1.26l-22.86-7c.2-.38.41-.76.62-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M259.41,177.06c-.1.4-.21.81-.32,1.22l-24.62-7.54.49-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M256.42,186.37c-.15.39-.3.78-.46,1.18l-25-7.64.42-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M252.72,194.64c-.19.38-.39.76-.59,1.14l-23.82-7.3c.12-.39.23-.8.36-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M248.54,201.93l-.33.51h0q-.41.24-.81.45l-20.92-6.4a11.3,11.3,0,0,1,.17-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M181.14,197.91s-1.79-4.41-3.54-6.07-33.34-19-47.21-7.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M185.08,209.52s1.1-5-5.2-13.39-45.9-23.41-51.22-9.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M134.27,199.13c.27.33.56.66.85,1a64.46,64.46,0,0,0,4.94,5.08c.31.28.62.57.95.85q2.46,2.22,5.39,4.41l1,.74a81.78,81.78,0,0,0,7.16,4.62l1.1.63c2.2,1.22,4.52,2.39,7,3.48l1.18.52c2.13.91,4.35,1.76,6.66,2.53l.57.19h0c.31,0,.61-.09.91-.15,10.51-2.06,15.31-14.27,12.36-18l-.1-.12a10.57,10.57,0,0,0-.93-.89c-1.16-1-3.1-2.49-5.53-4.2l-1-.72c-1.94-1.34-4.13-2.8-6.45-4.26l-1.07-.66c-2.4-1.49-4.91-3-7.38-4.3l-1.12-.59c-2.18-1.16-4.32-2.19-6.33-3l-1.19-.49-1.39-.51a53.53,53.53,0,0,0-5.54-1.62c-.45-.11-.89-.2-1.33-.29a31.23,31.23,0,0,0-8.89-.65c-.59.06-1.15.13-1.68.23-2.9.54-5,1.75-6,3.53-.49.87-.29,2.44.57,4.47.18.43.39.87.63,1.33A38.53,38.53,0,0,0,134.27,199.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M129.59,192.26l6.46-9.56c-.59.06-1.15.13-1.68.23l-5.41,8C129.14,191.36,129.35,191.8,129.59,192.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M134.27,199.13c.27.33.56.66.85,1l11.15-16.49c-.45-.11-.89-.2-1.33-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M140.06,205.21c.31.28.62.57.95.85l13.38-19.8-1.19-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M146.4,210.47l1,.74,14.42-21.33-1.12-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M154.58,215.83l1.1.63,14.61-21.62-1.07-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M162.65,219.94l1.18.52,13.95-20.64-1-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M170.49,223l.57.19h0c.31,0,.61-.09.91-.15l12.26-18.12a10.57,10.57,0,0,0-.93-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M261.06,152.33c-.11-.51-.22-1-.35-1.43-.61-2.12-1.44-3.47-2.37-3.84a5.65,5.65,0,0,0-2.11-.38,8,8,0,0,0-1-.15l0-.05h-.63a9.26,9.26,0,0,0-2.53.33c-4,.85-7.7,3.26-11.07,6.44-.24-2-.71-6.1-1.09-10.08a17.89,17.89,0,0,0-3.15-8.34,10.53,10.53,0,0,0-2.67-2.81s-2.55-9.62-8.55-11.9l-.34-.12-.18-.07h0a13.65,13.65,0,0,0-5.63-.83h0a4.91,4.91,0,0,0-1.06.15h0l-.26.06a7.18,7.18,0,0,0-1.28.43h0l-.33.14,0,0,0,0h0l0,0h0l0-.06v0l0-.07v0l0-.09h0a3.75,3.75,0,0,0,.13-.51v0a.59.59,0,0,0,0-.13v-.06s0-.09,0-.13v-.07s0-.1,0-.15v-.53c0-.16,0-.33,0-.52s0-.23,0-.36,0-.44-.09-.69a6.13,6.13,0,0,0,1.56-.57,6.94,6.94,0,0,0,2.41-2,2.29,2.29,0,0,0,0-2.77,3.34,3.34,0,0,0-1.88-1.08,14.83,14.83,0,0,0-2.94-.48,20.07,20.07,0,0,0-.25-3c0-.13,0-.26-.07-.39h0a11.46,11.46,0,0,0-.54-2s.59.4,1.58.93l.14.08.06,0,.09,0h0c2.28,1.19,6.3,2.82,9.95,2a9,9,0,0,0,1-.3,12.08,12.08,0,0,0,1.3-.58,10.34,10.34,0,0,0,4.57-4.5,12.35,12.35,0,0,0,3.59-.13,12,12,0,0,0,5-2.11,1.48,1.48,0,0,0,.71.43h0l.13,0h0l.11,0h0l.1,0h1.32l.56-.07h0l.29-.05h.07l.25-.06.09,0,.24-.06.11,0,.15,0,.12,0h.05c.12,0,.25-.07.37-.12,3.82-1.25,4.81-3.59,4.47-5.14a1.29,1.29,0,0,0-.86-.9h0a8.72,8.72,0,0,0-3.7-.14c-1.1.13-1.45-.14-1.07-1a.75.75,0,0,1,.07-.12l1.37-.63a12.16,12.16,0,0,0,2.42-1.46A4.52,4.52,0,0,0,251,85.8c-.18-.84-1-1.18-2.07-1.14a6.48,6.48,0,0,0-3.33,1.15c-1.9,1.33-2.72,1.11-3,0-.2-.77,1.2-2.12,2.47-3.41l.09-.09a2.08,2.08,0,0,0,1.12-1.19v0a1.63,1.63,0,0,0,.17-.2c1.24-1.58-.17-4.11-2.87-4.1a2.07,2.07,0,0,0-.77.14h0c-2,.78-2.17,4.44-3.48,4.17-1.47-.3-.68-1.66.8-3.9.2-.3.39-.61.58-1l.05-.09a.93.93,0,0,0,.34-.65h0l.08-.17,0,0s.05-.1.07-.16l0,0,.07-.16,0,0c.07-.16.13-.32.19-.49l0-.08s0-.07,0-.11l0-.1a.36.36,0,0,0,0-.11l0-.1,0-.1,0-.11,0-.1a.44.44,0,0,0,0-.1l0-.11s0-.07,0-.1a.36.36,0,0,0,0-.1s0-.07,0-.11,0-.06,0-.09,0-.12,0-.18,0-.07,0-.1,0-.07,0-.11v-.09a.34.34,0,0,0,0-.1v-.19a.28.28,0,0,0,0-.09v-.09s0-.06,0-.09,0-.06,0-.09,0-.06,0-.09,0-.06,0-.09a.24.24,0,0,1,0-.08l0-.09s0,0,0-.08l0-.1a.61.61,0,0,0-.05-.12.2.2,0,0,0,0-.08.43.43,0,0,0,0-.07l0-.08,0-.07-.05-.07,0-.07-.06-.06-.06-.06-.07-.07-.06-.05a.27.27,0,0,0-.08-.07l-.06,0-.1-.06-.06,0-.17-.09a1.9,1.9,0,0,0-1.55,0c-2.2.84-4.8,4.89-5.9,9.47a19.26,19.26,0,0,1-1.06,3.39c-.52,1.15-.88,1.08-1,1a.44.44,0,0,1-.09-.1c-.64-.64-1.82-5.27-2.65-8.18-.13-.48-.28-.93-.43-1.36-.8-2.23-1.9-3.82-3.37-3.91h-.59l-.08,0H224l-.19,0h0l-.17.06,0,0-.14.07h0l-.14.1,0,0-.13.11,0,0-.1.12,0,0-.1.15s0,0,0,0a.89.89,0,0,0-.08.17l0,0a1.59,1.59,0,0,1-.07.2v0c0,.07,0,.13,0,.2s0,0,0,.06,0,.16-.05.24v.07l0,.26v.07a2.13,2.13,0,0,0,0,.27v.86c0,.13,0,.26,0,.4a8.92,8.92,0,0,0,.26,1.69c.51,2,1.52,3.66,1.92,6a10.15,10.15,0,0,1,.13,1.93c-.31.12-.65.26-1,.43A10,10,0,0,0,222,85.43h0l-.19.16h0l0,0h0l-.28.26-.09.09-.18.17-.14.15-.12.13-.16.2-.06.06-.09.12a12.88,12.88,0,0,0-1.19-1.49,10.49,10.49,0,0,0-4.08-2.83c-.16-.4-.34-.78-.52-1.17-.5-3.38-1.41-7.84-2.2-8.43s-1.33-1.28-5.8-.82l-.38-.25a12.07,12.07,0,0,0,.56-1.47c.05-.72.07-1.44.06-2.14a15.19,15.19,0,0,0,3.11-1.28c1.11-.88-2.25-11.81-3.49-11.82-.44,0-2.69.28-3.7.4a18.41,18.41,0,0,0-15.59-7.64l-.5-1.12a14.7,14.7,0,0,0-9,2.82l.28.93a17.84,17.84,0,0,0-8.59,15.65c-.87.5-2.88,1.65-3.24,1.91-1,.75,2.86,11.52,4.27,11.57a14.5,14.5,0,0,0,3.18-.82c.34.45.69.88,1.06,1.31-4.09,1.58-6.67,2.89-7,3.42-.54.71.27,4.08,1,6.56-1.43,1-3.09,2.91-3.65,7,0,.2-.05.41-.07.62a2.07,2.07,0,0,0-.83.4,2.7,2.7,0,0,0-.67.76l-.12.2-.12.24a.14.14,0,0,1,0,.06l-.09.23,0,0-.09.3V100a2.46,2.46,0,0,0-.07.29v.06a2,2,0,0,0,0,.24s0,0,0,.08,0,.22,0,.33h0l0-.05h0l0-.06,0,0,0,0,0,0,0-.06,0,0-.06-.08,0,0a1.47,1.47,0,0,1-.1-.13.08.08,0,0,1,0,0l-.09-.1-.09-.09,0,0,0,0-.07-.07-.17-.14h0a4.73,4.73,0,0,0-.6-.42h0a7.87,7.87,0,0,0-2-.84c-.74-2.55-1.68-4.8-1.72-7,0-2.36.65-4.19.78-6.23a10,10,0,0,0-.05-1.72l-.06-.39v-.07l-.06-.34v-.08a2.82,2.82,0,0,0-.07-.31v0a2,2,0,0,0-.07-.26v-.06c0-.09-.06-.18-.08-.26l0-.06-.09-.23,0-.06-.09-.18,0,0-.1-.18,0,0L157.6,81l0,0-.12-.13,0,0-.12-.1,0,0-.14-.09,0,0-.16-.07h0l-.15,0h0a1,1,0,0,0-.18,0h-.62l-.09,0h-.07l-.17,0c-1.44.36-2.22,2.12-2.59,4.46-.07.46-.13.93-.17,1.42-.27,3-.58,7.78-1.08,8.53a.41.41,0,0,1-.07.12c-.14.16-.48.29-1.21-.74a20.41,20.41,0,0,1-1.67-3.13c-1.93-4.3-5.23-7.79-7.55-8.21a1.88,1.88,0,0,0-1.52.29.93.93,0,0,0-.15.13l-.05,0-.09.09,0,.06a.46.46,0,0,0-.07.07l-.05.07-.06.08a.43.43,0,0,0,0,.07l-.05.07a.3.3,0,0,1,0,.08l0,.08,0,.07a.29.29,0,0,0,0,.09l0,.07a.3.3,0,0,0,0,.1l0,.12s0,.07,0,.11a.25.25,0,0,1,0,.08.28.28,0,0,1,0,.09v.26a.28.28,0,0,1,0,.09,3225414727071.72,3225414727071.72,0,0,1,0,.18s0,.07,0,.1,0,.06,0,.09a.29.29,0,0,0,0,.09.36.36,0,0,0,0,.1s0,.06,0,.09l0,.1,0,.1.05.17,0,.09a.42.42,0,0,0,0,.1l0,.1.05.09a.3.3,0,0,0,0,.1,1,1,0,0,1,0,.1.93.93,0,0,1,.05.1l0,.09a.47.47,0,0,0,.05.1.41.41,0,0,0,.05.09l0,.1a.41.41,0,0,1,.05.09l.06.11,0,.07c.09.15.18.3.28.44l0,0,.1.14,0,0,.1.14,0,0,.11.15h0a.9.9,0,0,0,.45.57.27.27,0,0,0,.07.08c.24.3.5.57.74.82,1.87,1.93,2.9,3.13,1.52,3.69s-2.12-3-4.2-3.45h0a2,2,0,0,0-.78,0c-2.65.5-3.57,3.25-2.06,4.57l.2.17h0a2.09,2.09,0,0,0,1.32,1l.1.07c1.49,1,3.12,2.09,3.07,2.88-.09,1.11-.85,1.48-3,.52a6.56,6.56,0,0,0-3.48-.51c-1,.16-1.81.65-1.83,1.5a4.51,4.51,0,0,0,2,4.13,11.67,11.67,0,0,0,2.65,1l1.47.36.09.11c.53.75.23,1.09-.87,1.16a8.86,8.86,0,0,0-3.61.82h0a1.29,1.29,0,0,0-.68,1c0,1.58,1.36,3.7,5.35,4.22l.38,0h0l.13,0h1.24a4.86,4.86,0,0,0,.56,0h.06l.19,0h.07l.16,0,.08,0,.13,0h.08l.12,0,.07,0,.11,0,.07,0,.1,0,.06,0,.09,0,0,0,.1,0h0l.12-.07h0a1.59,1.59,0,0,0,.62-.56A11.66,11.66,0,0,0,148,113.4l-.13.18a18.79,18.79,0,0,0,10.79,5.27,13.82,13.82,0,0,0,3.87-.19,14.77,14.77,0,0,0,3-.91s2.7.74,6.52-1.43h0c.34-.2.7-.42,1.07-.67,0,0,.13.61.35,1.28,0,.16.1.31.15.47h0l-.08.06-.13.11-.28.24c-.91.82-2.81,2.65-2.61,3.72s1.17,1.59,2.76,1.56c-.14.08-.72.42-1.44.87h0c-1.07.65-2.46,1.53-3.22,2.11l-.06.05h0c-1.31,1-1.86,2.47-4.07,4.18s-2.17,3-3,6.52c-.37,1.55-.78,3.09-1.12,4.34-.44,1.62-.76,2.75-.76,2.75a13.49,13.49,0,0,0-1.52,1.74l0,.06,0,0-.06.09,0,0h0a15.64,15.64,0,0,0-1,1.56,12.66,12.66,0,0,0-.83,1.9,8.62,8.62,0,0,0-.33,1.16,32.2,32.2,0,0,0-.63,4.54c0,.61-.07,1.17-.08,1.65,0,1.08,0,1.76,0,1.76a12,12,0,0,0-1,1.4h0a15.55,15.55,0,0,0-1.39,2.83,12,12,0,0,0-.73,3.26c-.3,3.76,3.87,14.15,4.9,16.65-8.23-2.41-17.24-3.5-23.74-.22a9.34,9.34,0,0,0-2.18,1.33l-.5.39.06,0a7.51,7.51,0,0,0-.66.72,5.68,5.68,0,0,0-1.4,1.63c-.49.87-.29,2.44.57,4.47.18.43.39.87.63,1.33a38.53,38.53,0,0,0,4.68,6.87c.27.33.56.66.85,1a64.46,64.46,0,0,0,4.94,5.08c.31.28.62.57.95.85q2.46,2.22,5.39,4.41l1,.74a81.78,81.78,0,0,0,7.16,4.62l1.1.63c2.2,1.22,4.52,2.39,7,3.48l1.18.52c2.13.91,4.35,1.76,6.66,2.53l.57.19h0c.31,0,.61-.09.92-.15,7.67-1.5,12.3-8.43,13.09-13.51,0,0,0-.11,0-.33a6.72,6.72,0,0,0-.31-3.34,24.45,24.45,0,0,0-3.67-7.94,33.11,33.11,0,0,0-2.17-4.29,87.29,87.29,0,0,0-.13-10.55c-.52-5.34-2.23-9.49-2-12.35,0,0,2.55-1.18,4.64-10,.27-1.1.52-2.3.76-3.64l.18-.06c1.11-.35,6.73-2.37,8.95-7.36,2.47-5.54,4.94-6.34,6.27-5.49s6.9,6.17,15.09,5.77c0,0,.24.53.68,1.35h0a27.21,27.21,0,0,0,2.07,3.21,15,15,0,0,0,5.14,4.55,54.55,54.55,0,0,1,.77,11.32c-.12,5.12.46,11.45,2.24,15.31a35.19,35.19,0,0,0,.82,3.43,24.2,24.2,0,0,0,2.13,8.5,6.66,6.66,0,0,0,1.85,2.79l.24.22c3.8,3.46,11.76,5.95,18.68,2.29q.4-.21.81-.45h0l.33-.51c1.31-2.05,2.5-4.11,3.59-6.15.2-.38.4-.76.59-1.14,1.22-2.39,2.3-4.76,3.24-7.09.16-.4.31-.79.46-1.18a83.87,83.87,0,0,0,2.67-8.09c.11-.41.22-.82.32-1.22.61-2.36,1.08-4.64,1.44-6.82.07-.42.13-.84.19-1.26a64.74,64.74,0,0,0,.66-7c0-.45,0-.88,0-1.31A39.28,39.28,0,0,0,261.06,152.33ZM158,145.77h0v0Zm15.42-24.12-.19,0a1.13,1.13,0,0,1-.41-.16.4.4,0,0,1-.15-.17.31.31,0,0,1-.05-.1.72.72,0,0,1,0-.22,2,2,0,0,1,.24-.8l.16-.28c.12-.19.25-.38.38-.55a1.13,1.13,0,0,1,.1-.13l.18-.23c.28-.34.5-.56.5-.56A14.39,14.39,0,0,0,173.4,121.65Zm42.39-9.5h0s3.39-.59,3.92.16c.38.55.13,1.38-1.22,1.88a7.13,7.13,0,0,1-2,.4c-.17-.65-.39-1.36-.68-2.16C215.75,112.43,215.77,112.33,215.79,112.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M261.06,152.33c-.11-.51-.22-1-.35-1.43-.61-2.12-1.44-3.47-2.37-3.84a5.65,5.65,0,0,0-2.11-.38,8,8,0,0,0-1-.15l0-.05h-.63a9.26,9.26,0,0,0-2.53.33c-4,.85-7.7,3.26-11.07,6.44-.24-2-.71-6.1-1.09-10.08a17.89,17.89,0,0,0-3.15-8.34,10.53,10.53,0,0,0-2.67-2.81s-2.55-9.62-8.55-11.9l-.34-.12-.18-.07h0a13.65,13.65,0,0,0-5.63-.83h0a4.91,4.91,0,0,0-1.06.15h0l-.26.06a7.18,7.18,0,0,0-1.28.43h0l-.33.14,0,0,0,0h0l0,0h0l0-.06v0l0-.07v0l0-.09h0a3.75,3.75,0,0,0,.13-.51v0a.59.59,0,0,0,0-.13v-.06s0-.09,0-.13v-.07s0-.1,0-.15v-.53c0-.16,0-.33,0-.52s0-.23,0-.36,0-.44-.09-.69a6.13,6.13,0,0,0,1.56-.57,6.94,6.94,0,0,0,2.41-2,2.29,2.29,0,0,0,0-2.77,3.34,3.34,0,0,0-1.88-1.08,14.83,14.83,0,0,0-2.94-.48,20.07,20.07,0,0,0-.25-3c0-.13,0-.26-.07-.39h0a11.46,11.46,0,0,0-.54-2s.59.4,1.58.93l.14.08.06,0,.09,0h0c2.28,1.19,6.3,2.82,9.95,2a9,9,0,0,0,1-.3,12.08,12.08,0,0,0,1.3-.58,10.34,10.34,0,0,0,4.57-4.5,12.35,12.35,0,0,0,3.59-.13,12,12,0,0,0,5-2.11,1.48,1.48,0,0,0,.71.43h0l.13,0h0l.11,0h0l.1,0h1.32l.56-.07h0l.29-.05h.07l.25-.06.09,0,.24-.06.11,0,.15,0,.12,0h.05c.12,0,.25-.07.37-.12,3.82-1.25,4.81-3.59,4.47-5.14a1.29,1.29,0,0,0-.86-.9h0a8.72,8.72,0,0,0-3.7-.14c-1.1.13-1.45-.14-1.07-1a.75.75,0,0,1,.07-.12l1.37-.63a12.16,12.16,0,0,0,2.42-1.46A4.52,4.52,0,0,0,251,85.8c-.18-.84-1-1.18-2.07-1.14a6.48,6.48,0,0,0-3.33,1.15c-1.9,1.33-2.72,1.11-3,0-.2-.77,1.2-2.12,2.47-3.41l.09-.09a2.08,2.08,0,0,0,1.12-1.19v0a1.63,1.63,0,0,0,.17-.2c1.24-1.58-.17-4.11-2.87-4.1a2.07,2.07,0,0,0-.77.14h0c-2,.78-2.17,4.44-3.48,4.17-1.47-.3-.68-1.66.8-3.9.2-.3.39-.61.58-1l.05-.09a.93.93,0,0,0,.34-.65h0l.08-.17,0,0s.05-.1.07-.16l0,0,.07-.16,0,0c.07-.16.13-.32.19-.49l0-.08s0-.07,0-.11l0-.1a.36.36,0,0,0,0-.11l0-.1,0-.1,0-.11,0-.1a.44.44,0,0,0,0-.1l0-.11s0-.07,0-.1a.36.36,0,0,0,0-.1s0-.07,0-.11,0-.06,0-.09,0-.12,0-.18,0-.07,0-.1,0-.07,0-.11v-.09a.34.34,0,0,0,0-.1v-.19a.28.28,0,0,0,0-.09v-.09s0-.06,0-.09,0-.06,0-.09,0-.06,0-.09,0-.06,0-.09a.24.24,0,0,1,0-.08l0-.09s0,0,0-.08l0-.1a.61.61,0,0,0-.05-.12.2.2,0,0,0,0-.08.43.43,0,0,0,0-.07l0-.08,0-.07-.05-.07,0-.07-.06-.06-.06-.06-.07-.07-.06-.05a.27.27,0,0,0-.08-.07l-.06,0-.1-.06-.06,0-.17-.09a1.9,1.9,0,0,0-1.55,0c-2.2.84-4.8,4.89-5.9,9.47a19.26,19.26,0,0,1-1.06,3.39c-.52,1.15-.88,1.08-1,1a.44.44,0,0,1-.09-.1c-.64-.64-1.82-5.27-2.65-8.18-.13-.48-.28-.93-.43-1.36-.8-2.23-1.9-3.82-3.37-3.91h-.59l-.08,0H224l-.19,0h0l-.17.06,0,0-.14.07h0l-.14.1,0,0-.13.11,0,0-.1.12,0,0-.1.15s0,0,0,0a.89.89,0,0,0-.08.17l0,0a1.59,1.59,0,0,1-.07.2v0c0,.07,0,.13,0,.2s0,0,0,.06,0,.16-.05.24v.07l0,.26v.07a2.13,2.13,0,0,0,0,.27v.86c0,.13,0,.26,0,.4a8.92,8.92,0,0,0,.26,1.69c.51,2,1.52,3.66,1.92,6a10.15,10.15,0,0,1,.13,1.93c-.31.12-.65.26-1,.43A10,10,0,0,0,222,85.43h0l-.19.16h0l0,0h0l-.28.26-.09.09-.18.17-.14.15-.12.13-.16.2-.06.06-.09.12a12.88,12.88,0,0,0-1.19-1.49,10.49,10.49,0,0,0-4.08-2.83c-.16-.4-.34-.78-.52-1.17-.5-3.38-1.41-7.84-2.2-8.43s-1.33-1.28-5.8-.82l-.38-.25a12.07,12.07,0,0,0,.56-1.47c.05-.72.07-1.44.06-2.14a15.19,15.19,0,0,0,3.11-1.28c1.11-.88-2.25-11.81-3.49-11.82-.44,0-2.69.28-3.7.4a18.41,18.41,0,0,0-15.59-7.64l-.5-1.12a14.7,14.7,0,0,0-9,2.82l.28.93a17.84,17.84,0,0,0-8.59,15.65c-.87.5-2.88,1.65-3.24,1.91-1,.75,2.86,11.52,4.27,11.57a14.5,14.5,0,0,0,3.18-.82c.34.45.69.88,1.06,1.31-4.09,1.58-6.67,2.89-7,3.42-.54.71.27,4.08,1,6.56-1.43,1-3.09,2.91-3.65,7,0,.2-.05.41-.07.62a2.07,2.07,0,0,0-.83.4,2.7,2.7,0,0,0-.67.76l-.12.2-.12.24a.14.14,0,0,1,0,.06l-.09.23,0,0-.09.3V100a2.46,2.46,0,0,0-.07.29v.06a2,2,0,0,0,0,.24s0,0,0,.08,0,.22,0,.33h0l0-.05h0l0-.06,0,0,0,0,0,0,0-.06,0,0-.06-.08,0,0a1.47,1.47,0,0,1-.1-.13.08.08,0,0,1,0,0l-.09-.1-.09-.09,0,0,0,0-.07-.07-.17-.14h0a4.73,4.73,0,0,0-.6-.42h0a7.87,7.87,0,0,0-2-.84c-.74-2.55-1.68-4.8-1.72-7,0-2.36.65-4.19.78-6.23a10,10,0,0,0-.05-1.72l-.06-.39v-.07l-.06-.34v-.08a2.82,2.82,0,0,0-.07-.31v0a2,2,0,0,0-.07-.26v-.06c0-.09-.06-.18-.08-.26l0-.06-.09-.23,0-.06-.09-.18,0,0-.1-.18,0,0L157.6,81l0,0-.12-.13,0,0-.12-.1,0,0-.14-.09,0,0-.16-.07h0l-.15,0h0a1,1,0,0,0-.18,0h-.62l-.09,0h-.07l-.17,0c-1.44.36-2.22,2.12-2.59,4.46-.07.46-.13.93-.17,1.42-.27,3-.58,7.78-1.08,8.53a.41.41,0,0,1-.07.12c-.14.16-.48.29-1.21-.74a20.41,20.41,0,0,1-1.67-3.13c-1.93-4.3-5.23-7.79-7.55-8.21a1.88,1.88,0,0,0-1.52.29.93.93,0,0,0-.15.13l-.05,0-.09.09,0,.06a.46.46,0,0,0-.07.07l-.05.07-.06.08a.43.43,0,0,0,0,.07l-.05.07a.3.3,0,0,1,0,.08l0,.08,0,.07a.29.29,0,0,0,0,.09l0,.07a.3.3,0,0,0,0,.1l0,.12s0,.07,0,.11a.25.25,0,0,1,0,.08.28.28,0,0,1,0,.09v.26a.28.28,0,0,1,0,.09,3225414727071.72,3225414727071.72,0,0,1,0,.18s0,.07,0,.1,0,.06,0,.09a.29.29,0,0,0,0,.09.36.36,0,0,0,0,.1s0,.06,0,.09l0,.1,0,.1.05.17,0,.09a.42.42,0,0,0,0,.1l0,.1.05.09a.3.3,0,0,0,0,.1,1,1,0,0,1,0,.1.93.93,0,0,1,.05.1l0,.09a.47.47,0,0,0,.05.1.41.41,0,0,0,.05.09l0,.1a.41.41,0,0,1,.05.09l.06.11,0,.07c.09.15.18.3.28.44l0,0,.1.14,0,0,.1.14,0,0,.11.15h0a.9.9,0,0,0,.45.57.27.27,0,0,0,.07.08c.24.3.5.57.74.82,1.87,1.93,2.9,3.13,1.52,3.69s-2.12-3-4.2-3.45h0a2,2,0,0,0-.78,0c-2.65.5-3.57,3.25-2.06,4.57l.2.17h0a2.09,2.09,0,0,0,1.32,1l.1.07c1.49,1,3.12,2.09,3.07,2.88-.09,1.11-.85,1.48-3,.52a6.56,6.56,0,0,0-3.48-.51c-1,.16-1.81.65-1.83,1.5a4.51,4.51,0,0,0,2,4.13,11.67,11.67,0,0,0,2.65,1l1.47.36.09.11c.53.75.23,1.09-.87,1.16a8.86,8.86,0,0,0-3.61.82h0a1.29,1.29,0,0,0-.68,1c0,1.58,1.36,3.7,5.35,4.22l.38,0h0l.13,0h1.24a4.86,4.86,0,0,0,.56,0h.06l.19,0h.07l.16,0,.08,0,.13,0h.08l.12,0,.07,0,.11,0,.07,0,.1,0,.06,0,.09,0,0,0,.1,0h0l.12-.07h0a1.59,1.59,0,0,0,.62-.56A11.66,11.66,0,0,0,148,113.4l-.13.18a18.79,18.79,0,0,0,10.79,5.27,13.82,13.82,0,0,0,3.87-.19,14.77,14.77,0,0,0,3-.91s2.7.74,6.52-1.43h0c.34-.2.7-.42,1.07-.67,0,0,.13.61.35,1.28,0,.16.1.31.15.47h0l-.08.06-.13.11-.28.24c-.91.82-2.81,2.65-2.61,3.72s1.17,1.59,2.76,1.56c-.14.08-.72.42-1.44.87h0c-1.07.65-2.46,1.53-3.22,2.11l-.06.05h0c-1.31,1-1.86,2.47-4.07,4.18s-2.17,3-3,6.52c-.37,1.55-.78,3.09-1.12,4.34-.44,1.62-.76,2.75-.76,2.75a13.49,13.49,0,0,0-1.52,1.74l0,.06,0,0-.06.09,0,0h0a15.64,15.64,0,0,0-1,1.56,12.66,12.66,0,0,0-.83,1.9,8.62,8.62,0,0,0-.33,1.16,32.2,32.2,0,0,0-.63,4.54c0,.61-.07,1.17-.08,1.65,0,1.08,0,1.76,0,1.76a12,12,0,0,0-1,1.4h0a15.55,15.55,0,0,0-1.39,2.83,12,12,0,0,0-.73,3.26c-.3,3.76,3.87,14.15,4.9,16.65-8.23-2.41-17.24-3.5-23.74-.22a9.34,9.34,0,0,0-2.18,1.33l-.5.39.06,0a7.51,7.51,0,0,0-.66.72,5.68,5.68,0,0,0-1.4,1.63c-.49.87-.29,2.44.57,4.47.18.43.39.87.63,1.33a38.53,38.53,0,0,0,4.68,6.87c.27.33.56.66.85,1a64.46,64.46,0,0,0,4.94,5.08c.31.28.62.57.95.85q2.46,2.22,5.39,4.41l1,.74a81.78,81.78,0,0,0,7.16,4.62l1.1.63c2.2,1.22,4.52,2.39,7,3.48l1.18.52c2.13.91,4.35,1.76,6.66,2.53l.57.19h0c.31,0,.61-.09.92-.15,7.67-1.5,12.3-8.43,13.09-13.51,0,0,0-.11,0-.33a6.72,6.72,0,0,0-.31-3.34,24.45,24.45,0,0,0-3.67-7.94,33.11,33.11,0,0,0-2.17-4.29,87.29,87.29,0,0,0-.13-10.55c-.52-5.34-2.23-9.49-2-12.35,0,0,2.55-1.18,4.64-10,.27-1.1.52-2.3.76-3.64l.18-.06c1.11-.35,6.73-2.37,8.95-7.36,2.47-5.54,4.94-6.34,6.27-5.49s6.9,6.17,15.09,5.77c0,0,.24.53.68,1.35h0a27.21,27.21,0,0,0,2.07,3.21,15,15,0,0,0,5.14,4.55,54.55,54.55,0,0,1,.77,11.32c-.12,5.12.46,11.45,2.24,15.31a35.19,35.19,0,0,0,.82,3.43,24.2,24.2,0,0,0,2.13,8.5,6.66,6.66,0,0,0,1.85,2.79l.24.22c3.8,3.46,11.76,5.95,18.68,2.29q.4-.21.81-.45h0l.33-.51c1.31-2.05,2.5-4.11,3.59-6.15.2-.38.4-.76.59-1.14,1.22-2.39,2.3-4.76,3.24-7.09.16-.4.31-.79.46-1.18a83.87,83.87,0,0,0,2.67-8.09c.11-.41.22-.82.32-1.22.61-2.36,1.08-4.64,1.44-6.82.07-.42.13-.84.19-1.26a64.74,64.74,0,0,0,.66-7c0-.45,0-.88,0-1.31A39.28,39.28,0,0,0,261.06,152.33ZM158,145.77h0v0Zm15.42-24.12-.19,0a1.13,1.13,0,0,1-.41-.16.4.4,0,0,1-.15-.17.31.31,0,0,1-.05-.1.72.72,0,0,1,0-.22,2,2,0,0,1,.24-.8l.16-.28c.12-.19.25-.38.38-.55a1.13,1.13,0,0,1,.1-.13l.18-.23c.28-.34.5-.56.5-.56A14.39,14.39,0,0,0,173.4,121.65Zm42.39-9.5h0s3.39-.59,3.92.16c.38.55.13,1.38-1.22,1.88a7.13,7.13,0,0,1-2,.4c-.17-.65-.39-1.36-.68-2.16C215.75,112.43,215.77,112.33,215.79,112.15Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError503);
export default __webpack_public_path__ + "static/media/error503.8d635202edcfcf5e2ede27828ca5f0fe.svg";
export { ForwardRef as ReactComponent };